export default __webpack_public_path__ + "static/media/oneclick.977db105.png";